<template>
  <div class="home">
    <l-container>
      <h1>系统使用统计概览</h1>
      <div class="chartBox">
        <div class="box">
          <h3>本月测评结果统计</h3>
          <div ref="bar" style="width:4.4rem;height:2.5rem"></div>
        </div>
        <div class="box">
          <h3>{{level==1 || level==2 || level==3 ? '本月测评人数统计' : '每日测评次数统计'}}</h3>
          <p style="margin: .1rem 0 0 .3rem;">共{{testTotalNum}}{{level==1 || level==2 || level==3 ? '人' : '次'}}</p>
          <div ref="line" style="width:4.64rem;height:2.2rem"></div>
          <p class="floatDate">{{new Date().getFullYear()+'年'+ (new Date().getMonth()+1) +'月'}}</p>
        </div>
        <div class="box" @click="level==1 || level==2 || level==3 ? $router.push('warning/list') : ''">
          <h3>{{level==1 || level==2 || level==3 ? '本月测评预警统计' : '本月咨询/预约专家次数'}}</h3>
          <div class="warnin">
            <div style="width:2rem;text-align:center">
              <div ref="gauge" style="width:2rem;height:1.2rem"></div>
              <p style="margin-bottom:.10rem">{{warn}}{{level==1 || level==2 || level==3 ? '份' : '次'}}</p>
              <p style="font-size:.14rem;color:#999">{{level==1 || level==2 || level==3 ? '共有预警结果' : '共预约咨询次数'}}</p>
            </div>
            <div>
              <p
                style="font-size:.15rem;margin-bottom:.32rem"
              >{{level==1 || level==2 || level==3 ? '本月测评预警人数共' : '本月您预约/咨询过专家'}}：{{warnNum}}{{level==1 || level==2 || level==3 ? '人' : '次'}}</p>
              <div>
                <p
                  style="font-size:.14rem"
                >{{level==1 || level==2 || level==3 ? '预警男用户' : '咨询次数'}}：{{warnMan}}{{level==1 || level==2 || level==3 ? '人' : '次'}}</p>
                <div class="progress p1">
                  <div :style="{'width': warningManOrConsult,}"></div>
                </div>
              </div>
              <div style="margin-top:.3rem">
                <p
                  style="font-size:.14rem"
                >{{level==1 || level==2 || level==3 ? '预警女用户' : '预约次数'}}：{{warnWoman}}{{level==1 || level==2 || level==3 ? '人' : '次'}}</p>
                <div class="progress p2">
                  <div :style="{'width': warningWoManOrRegister,}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2>各项数据统计</h2>
      <div class="table">
        <div class="childtable">
          <table>
            <tr class="theard">
              <th style="width:2.8rem">数据类别</th>
              <th style="width:2rem">统计数据</th>
              <th style="width:1.5rem">单位</th>
              <th style="width:3.6rem">在该项数据统计内的占比</th>
              <th style="width:2rem">显示在首页</th>
              <th style="width:2.4rem">更改显示操作</th>
            </tr>
            
            <tr
              v-for="(item, index) of reportKeyData" :key="index"
              v-show="allData.setting[item.key] == isStatus"
            >
              <td>
                <div class="td1">
                  <img :src="item.img" alt />
                  <span>{{allData.data[item.key].name}}</span>
                </div>
              </td>
              <td>{{allData.data[item.key].statistic}}</td>
              <td>{{allData.data[item.key].unit}}</td>
              <td>{{allData.data[item.key].ratio}}</td>
              <td>{{allData.setting[item.key]==1 ? '显示' : '不显示'}}</td>
              <td>
                <el-switch
                  v-model="allData.setting[item.key]"
                  active-color="#F0F0F0"
                  :active-value="1"
                  :inactive-value="0"
                  @change="switchChange(item.key)"
                ></el-switch>
              </td>
            </tr>
          </table>
        </div>
        <div
          style="color:#222;text-align:center;margin-top:.1rem;cursor: pointer;"
          @click="isStatus = !isStatus"
        >{{isStatus ? '查看隐藏的选项' : '关闭'}}</div>
      </div>
    </l-container>
  </div>
</template>

<script>
// let myBar = null;
// let myLine = null;
// let myGauge = null;
import * as echarts from "echarts";
import lContainer from "@/components/lContainer.vue";
export default {
  data() {
    return {
      level: JSON.parse(localStorage.getItem("userinfo"))?.level,
      isStatus: true,
      init: false,
      //report: {}, //报告
      userList: {}, //用户
      allData: {},
      tsetNums: [],
      tsetUserNum: [],
      testTotalNum: 0, //测评总人数
      warn: 0,
      warnNum: 0,
      warnMan: 0,
      warnWoman: 0,
      warnRatio: 0,
      userReport: {},
      report: {
        reportTotal: {
          gauge: 0,
          questionnaire: 0,
          survey: 0,
          warning: 0,
          warningNum: 0,
          warningMan: 0,
          warningWoman: 0,
          total: 0,
        },
        expert: { consultTotal: 0, reserveTotal: 0, expertTotal: 0 },
      },
      reportKeyData: []
    };
  },
  methods: {
    //获取用户数据
    async getUserReport() {
      let { data } = await this.$post("api/test/statics");
      console.log(data);
      this.userReport = data.data.list;
      //测评结果统计
      this.tsetNums = [
        this.userReport.test.testTotal.num,
        this.userReport.test.gauge.num,
        this.userReport.test.questionnaire.num,
        this.userReport.test.survey.num,
      ];
      //每日测评次数
      this.tsetUserNum = this.userReport.evaluation.map((item) => {
        return [new Date(item.time).getDate(), item.num];
      });
      this.userReport.evaluation.forEach((item) => {
        this.testTotalNum += Number(item.num);
      });
      //咨询专家
      let ratio = this.userReport.catTotal.proportion.replace(/％/g, "");
      this.warnRatio = +ratio;
      // this.warn = this.userReport.catTotal.all;
      this.warn = this.userReport.catTotal.month;
      this.warnNum = this.userReport.catTotal.month; // 预约/咨询次数
      this.warnMan = this.userReport.catTotal.consulted; // 咨询次数
      this.warnWoman = this.userReport.catTotal.reserve; // 预约次数
    },

    //获取管理员报告数据
    async getReport() {
      let { data } = await this.$post("api/test/reportStatic", {
        status: 1,
      });
      this.report = data.data.list;
      //获取人数
      let total =
        this.report.reportTotal.gauge +
        this.report.reportTotal.questionnaire +
        this.report.reportTotal.survey;
      this.tsetNums = [
        total,
        this.report.reportTotal.gauge,
        this.report.reportTotal.questionnaire,
        this.report.reportTotal.survey,
      ];
      //获取本月测评人数
      this.tsetUserNum = this.report.curMonthTestPeopleTotal.map(
        (item, index) => {
          return [index + 1, item.Total];
        }
      );
      this.report.curMonthTestPeopleTotal.forEach((item) => {
        this.testTotalNum += Number(item.Total);
      });
      //预警
      this.warn = this.report.reportTotal.warning; // 共有预警结果
      // this.warn = this.report.reportTotal.warningNum;
      this.warnNum = this.report.reportTotal.warningNum; // 本月测评预警人数共
      this.warnMan = this.report.reportTotal.warningMan; // 预警男用户
      this.warnWoman = this.report.reportTotal.warningWoman; // 预警女用户

      let warnRatio = 0
      if (this.warn >= 0) {
        if (this.report.reportTotal.totalIncludeWarning > 0) {
          warnRatio = +((this.warn / this.report.reportTotal.totalIncludeWarning) * 100).toFixed(0)
        } else {
          warnRatio = 0
        }
      }
      this.warnRatio = warnRatio
    },
    //获取用户数据
    async getUser() {
      let { data } = await this.$post("api/msg/userStatic", {
        status: 1,
      });
      this.userList = data.data.list;
      this.userList.manTotal_bl = Math.floor((this.userList.manTotal/this.userList.total)*100)
      this.userList.womanTotal_bl = 100 - this.userList.manTotal_bl
    },
    //获取各项数据统计
    async getAllData() {
      let { data } = await this.$post("api/test/statistics", { type: 1 });
      this.allData = data.data.list;
      console.log(this.allData);
      this.init = true;
      let itemList1 = [
        { key: 'consultTotal', name: '专家被咨询', img: require('@/assets/img/home/t11.png'), },
        { key: 'reserveTotal', name: '专家被预约', img: require('@/assets/img/home/t12.png'), },
      ],
      itemList2 = [
        { key: 'headcount', name: '用户总数', img: require('@/assets/img/home/t1.png'), },
        { key: 'man', name: '男性用户', img: require('@/assets/img/home/t2.png'), },
        { key: 'woman', name: '女性用户', img: require('@/assets/img/home/t3.png'), },
        { key: 'testTotal', name: '所有测评结果数', img: require('@/assets/img/home/t4.png'), },
        { key: 'gauge', name: '量表测评结果', img: require('@/assets/img/home/t5.png'), },
        { key: 'survey', name: '普查测评结果', img: require('@/assets/img/home/t6.png'), },
        { key: 'questionnaire', name: '问卷测评结果', img: require('@/assets/img/home/t7.png'), },
        { key: 'warning', name: '预警测评结果', img: require('@/assets/img/home/t8.png'), },
        { key: 'team', name: '团体测评结果', img: require('@/assets/img/home/t9.png'), },
        { key: 'manager', name: '管理员人数', img: require('@/assets/img/home/t1.png'), },
        { key: 'expert', name: '专家人数', img: require('@/assets/img/home/t10.png'), },
      ]
      let arr = [], reportKeyData = []
      if (this.level == 3) {
        // 咨询师
        arr = [...itemList1, ...itemList2]
      } else {
        arr = [...itemList2, ...itemList1]
      }
      arr.forEach((item)=>{
        if (item.key in this.allData.setting) {
          reportKeyData.push(item)
        }
      })
      this.reportKeyData = reportKeyData
    },
    switchChange(key) {
      console.log(this.allData.setting[key]);
      this.$post("api/test/statistics", { type: 2, setting: this.allData });
      this.$myMessage('设置成功');
    },
    handEchart() {
      let myBar = this.echarts.init(this.$refs.bar);
      let myLine = this.echarts.init(this.$refs.line);
      let myGauge = this.echarts.init(this.$refs.gauge);
      //柱图
      let barOption = {
        grid: {
          top: 30,
          left: 50,
          right: 0,
          bottom: 30,
        },
        xAxis: {
          type: "category",
          data: ["全部", "量表", "问卷", "普查"],
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#ccc",
            },
          },
          axisLabel: {
            color: "#333",
            fontSize: ".15rem",
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: this.tsetNums,
            type: "bar",
            barWidth: "15%", //柱图宽度
            itemStyle: {
              borderRadius: 50, //柱形图圆角
              color: function (params) {
                let colors = ["#004EFF", "#FF500C", "#159BE0", "#EFBC00"];
                return colors[params.dataIndex];
              },
            },
          },
        ],
      };
      //
      let _this = this;
      let lineOption = {
        grid: {
          top: 30,
          left: 40,
          right: 0,
          bottom: 30,
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            return (
              params[0].value[1] +
              (_this.level == 1 || _this.level == 2 || _this.level == 3 ? "人" : "次")
            );
          },
        },
        xAxis: {
          type: "category",
          //data: ["16", "17", "18", "19", "20", "21", "22"],
          axisTick: {
            inside: true,
          },
          axisLine: {
            lineStyle: {
              color: "#ccc",
            },
          },
          axisLabel: {
            color: "#333",
            fontSize: ".15rem",
          },
        },
        yAxis: {
          // show: false,
          type: "value",
          // splitLine: {
          //   show: false,
          //   axisTick: {
          //     show: false,
          //   },
          // },
        },
        dataZoom: [
          {
            show: true,
            type: "inside",
            filterMode: "none",
            xAxisIndex: [0],
            startValue: new Date().getDate() - 9,
            endValue: new Date().getDate(),
          },
        ],
        series: [
          {
            data: this.tsetUserNum,
            type: "line",
            smooth: true,
            showSymbol: false,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(0, 78, 255, .3)",
                },
                {
                  offset: 0.5,
                  color: "rgba(0, 78, 255, .1)",
                },
                {
                  offset: 1,
                  color: "rgba(0, 78, 255, 0)",
                },
              ]),
            },
          },
        ],
      };
      //仪表图
      let gaugeOption = {
        series: [
          {
            type: "gauge",
            //条形颜色
            itemStyle: {
              color: "#EFBC00",
            },
            radius: "100%",
            //条形样式
            progress: {
              show: true,
              width: 8,
              roundCap: true,
            },
            pointer: {
              show: false,
            },
            //灰色条形
            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 8,
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            anchor: {},
            title: {
              offsetCenter: [0, "40%"],
              fontSize: ".15rem",
            },
            //数据
            detail: {
              borderRadius: 20,
              offsetCenter: [0, "0%"],
              fontSize: ".28rem",
              fontWeight: "400",
              formatter: "{value}%",
              color: "#333",
            },
            data: [
              {
                value: this.warnRatio,
                name:
                  this.level == 1 || this.level == 2 || this.level == 3 ? "预警占比" : "预约占比",
              },
            ],
          },
        ],
      };
      myBar.setOption(barOption);
      myLine.setOption(lineOption);
      myGauge.setOption(gaugeOption);
      window.addEventListener("resize", function () {
        myBar.resize();
        myLine.resize();
        myGauge.resize();
      });
      myBar.on("click", (params) => {
        console.log(params.name);
        if (params.name == "量表") {
          this.$router.push("scale/scaleResult");
        } else if (params.name == "问卷") {
          this.$router.push("question/result");
        } else if (params.name == "普查") {
          this.$router.push("survey/surveyResult");
        }
      });
    },
  },
  computed: {
    warningMan() {
      if (!this.report.reportTotal?.warningMan) {
        return 0
      }
      return Math.floor(
        (this.report.reportTotal?.warningMan /
          this.report.reportTotal?.warningNum) *
          100
      );
    },
    warningWoMan() {
      if (!this.report.reportTotal?.warningWoman) {
        return 0
      }
      return Math.floor(
        (this.report.reportTotal?.warningWoman /
          this.report.reportTotal?.warningNum) *
          100
      );
    },
    warningManOrConsult() {
      if (this.level==1 || this.level==2 || this.level==3) {
        if (!this.report.reportTotal?.warningMan) {
          return '0%'
        }
        return Math.floor(
          (this.report.reportTotal?.warningMan /
            this.report.reportTotal?.warningNum) *
            100
        ) + '%';
      } else {
        if (!this.userReport.catTotal?.consulted) {
          return '0%'
        }
        return Math.floor(
          (this.userReport.catTotal?.consulted /
            this.userReport.catTotal?.month) *
            100
        ) + '%';
      }
    },
    warningWoManOrRegister() {
      if (this.level==1 || this.level==2 || this.level==3) {
        if (!this.report.reportTotal?.warningWoman) {
          return '0%'
        }
        return Math.floor(
          (this.report.reportTotal?.warningWoman /
            this.report.reportTotal?.warningNum) *
            100
        ) + '%';
      } else {
        if (!this.userReport.catTotal?.reserve) {
          return '0%'
        }
        return Math.floor(
          (this.userReport.catTotal?.reserve /
            this.userReport.catTotal?.month) *
            100
        ) + '%';
      }
    },
    consult() {
      if (!this.userReport.catTotal?.consulted) {
        return 0
      }
      return Math.floor(
        (this.userReport.catTotal?.consulted /
          this.userReport.catTotal?.month) *
          100
      );
    },
    register() {
      if (!this.userReport.catTotal?.reserve) {
        return 0
      }
      return Math.floor(
        (this.userReport.catTotal?.reserve / this.userReport.catTotal?.month) *
          100
      );
    },
  },
  components: {
    "l-container": lContainer,
  },
  async mounted() {
    this.getAllData();
    if (this.level == 1 || this.level == 2 || this.level == 3) {
      await this.getReport();
    } else {
      await this.getUserReport();
    }
    await this.getUser();
    this.handEchart();
  },
};
</script>

<style scoped lang='less'>
/deep/.slot {
  h1 {
    color: #fff;
    font-weight: 400;
    font-size: 18px;
    margin-left: 2px;
  }
  .chartBox {
    margin-top: 33px;
    display: flex;
    .box {
      position: relative;
      height: 300px;
      width: 465px;
      background: #ffffff;
      border-radius: 10px;
      margin-right: 16px;
      &:last-child {
        margin-right: 0;
      }
      .floatDate {
        position: absolute;
        padding-left: 30px;
        font-size: 15px;
        color: #333;
        bottom: 6px;
        line-height: 23px;
        width: 100px;
        background: #fff;
      }
    }
    h3 {
      color: #333;
      font-weight: 400;
      font-size: 18px;
      margin: 25px 0 0 30px;
    }
    .warnin {
      margin-top: 40px;
      display: flex;
      .progress {
        width: 230px;
        height: 12px;
        border-radius: 6px;
        margin-top: 9px;
      }
      .p1 {
        background: rgba(0, 78, 255, 0.1);
        div {
          background: rgba(0, 78, 255);
          height: 12px;
          border-radius: 6px;
        }
      }
      .p2 {
        background: rgba(255, 80, 12, 0.1);
        div {
          background: rgba(255, 80, 12);
          height: 12px;
          border-radius: 6px;
        }
      }
    }
  }
  h2 {
    color: #555555;
    font-weight: 400;
    font-size: 18px;
    margin: 34px 0 28px 2px;
  }
  .table {
    width: 1430px;
    height: 525px;
    background: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    table {
      border-collapse: collapse;
    }
    .childtable {
      height: 480px;
      overflow: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    tr {
      box-sizing: border-box;
    }
    th {
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      color: #333;
      font-weight: 400;
      background: #fafbfc;
    }
    td {
      text-align: center;
      font-size: 14px;
      height: 59px;
      border-bottom: 1px solid #f0f0f0;
    }
    .td1 {
      display: flex;
      align-items: center;
      margin-left: 50px;
      // position: relative;
      // top: 10px;
      img {
        height: 40px;
        width: 40px;
        border-radius: 50%;
        margin-right: 29px;
      }
      span {
        color: #303030;
      }
    }
    .el-switch {
      .el-switch__core{
        width: 52px !important;
        height: 26px;
        background: #f0f0f0;
        border-radius: 13px;
      }
      .el-switch__core::after {
        background: #aaa;
      }
    }
    .el-switch.is-checked {
      .el-switch__core::after {
        left: 100%;
        background: #004eff;
        margin-left: -0.25rem;
      }
    }
    .el-switch__core {
      height: 26px;
      width: 52px;
      border-radius: 18px;
      &::after {
        top: -1px;
        left: -1px;
        width: 26px;
        height: 26px;
        background: #004eff;
      }
    }
  }
}
</style>
